import { render } from "./Page.vue?vue&type=template&id=754ec509"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jc/Library/CloudStorage/Dropbox/Workspace/kolter-homes/projects/current/sales-center-kiosk/kiosk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__